import React, { useEffect, useMemo } from 'react';
// 使用require导入来避免TypeScript解析问题
const { IndexCard } = require('@sto/index-card');
import styles from './index.module.scss';
import { formatValueToWan } from '@/utils/tools';
/**
 * STO指标卡组件
 * @param content 指标卡内容
 * @param question 问题
 * @returns 指标卡组件
 */
const CMetricCard = ({ content, question, requestId }) => {
  const { dataSource = [], mapConfig = {}, time = '' } = content;

  useEffect(() => {
    if (time) {
      const titleBox = document.getElementById(`metricCardBox-${requestId}`).querySelector('.index-card-content .main-index-box .main-title');
      if (titleBox) {
        const timeBox = document.getElementById(`timeBox-${requestId}`);
        if (timeBox) {
          timeBox.style.left = `${titleBox.clientWidth + 20}px`;
        }
      }      
    }
  }, [time]);

  const formatDataSource = useMemo(() => {
    return dataSource.map((item) => {
      if (item.idx5 && item.idx5.metricNames) {
        item.idx5 = item.idx5.metricNames[0]; // 取第一个指标名称作为label
      }
      Object.keys(item).forEach((key) => {
        const value = item[key];
        if (value && typeof value === 'string' || typeof value === 'number') {
          item[key] = formatValueToWan(value);
        }
      })
      return item;
    })
  }, [dataSource])

  return (
    <div className={styles.metricCardBox} id={`metricCardBox-${requestId}`}>
      {/* 2026-02-27 新程说新样式，没有这个时间展示了 */}
      {/* <div className={styles.time} id={`timeBox-${requestId}`}>{time}</div> */}
      <IndexCard
        size="small"
        useCard
        dataSource={formatDataSource}
        mapConfig={mapConfig}
      />
    </div>
  );
};

export default CMetricCard;